// extracted by mini-css-extract-plugin
module.exports = {"reportContainer":"ReportProduct_reportContainer__cTx5F","reportLink":"ReportProduct_reportLink__ZFVay","icon":"ReportProduct_icon__GmTxK"};